import React from "react";
import { AppBar, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { isRedirectedFromMobileApp } from "Utils/RedirectedFromMobileApp";
import Logo from "Pages/Components/Logo";
import AuthActionsV2 from "Pages/Components/CheckoutV2/AuthActionsV2";

/**
 * Standalone header for the CheckoutV2 (donate redesign) page. It is rendered
 * by {@link DefaultLayout} in place of the shared site {@link Header} so the
 * donate flow can evolve its own chrome without touching the main header.
 *
 * It overlays the hero transparently and shows just the (monochrome) logo and
 * a "Log in/Sign up" button — no nav items, donate button, or banner.
 */
const HeaderV2 = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  if (isRedirectedFromMobileApp()) return null;

  return (
    <AppBar
      position="absolute"
      className="mui-fixed"
      elevation={0}
      sx={{ background: "transparent", boxShadow: "none" }}
    >
      <Toolbar sx={{ justifyContent: "space-between", background: "transparent" ,height:80,minHeight:80}}>
        <Link
          to="/"
          style={{
            display: "block",
            alignSelf: "center",
            minWidth: 60,
            maxWidth: 101,
            width: "100%",
          }}
        >
          <Logo monochrome />
        </Link>

        <AuthActionsV2
          size={isSmall ? "small" : "medium"}
          donationPageV2
          sx={{ ml: isMobile ? 1 : 2 }}
        />
      </Toolbar>
    </AppBar>
  );
};

export default HeaderV2;
